export default __webpack_public_path__ + "static/media/gallery-8-3.d35f6bb2.webp";